<div class="table-layout">
    <div class="table-operation">
        <button nButton id="homedir-rule-cifs-share-refresh" style="float: right;" icon="icon-refresh" (click)="refresh()">
        </button>
        <n-button-group [relateTable]="dt" [items]="[addBtn, deleteBtn]">
        </n-button-group>
    </div>
    <div class="table-container">
        <n-data-table #dt id="homedir-rule-cifs-share-table" style="height: 4rem;" [config]="tableConfig" [columnDefs]="tableColumnDefs" [rest]="tableRest"
            [countRest]="tableCountRest" [(selection)]="selection">
        </n-data-table>
    </div>
</div>
